// extracted by mini-css-extract-plugin
module.exports = {"root":"price-module__root___2bclt","title":"price-module__title___1Ml2U","text":"price-module__text___1rpXV"};